import React from 'react'
import '../../App.css'
import ContactPage from '../ContactPage';
import Footer from '../Footer';

function Contact() {
    return (
        <>
          <ContactPage />
          <Footer/>
        </>
    )
}

export default Contact;